import React, { useState } from 'react';
import AuthPage from './components/AuthPage';
import ChatDialog from './components/ChatDialog';
import { getAuthedUser, clearAuthedUser } from './services/authStorage';
import './App.css';

function App() {
  const initialAuthedUser = getAuthedUser();
  const [authedUser, setAuthedUser] = useState(initialAuthedUser);
  const [isAuthed, setIsAuthed] = useState(Boolean(initialAuthedUser));

  const handleAuthSuccess = (user) => {
    setAuthedUser(user);
    setIsAuthed(Boolean(user));
  };

  const handleLogout = () => {
    clearAuthedUser();
    setAuthedUser(null);
    setIsAuthed(false);
  };

  return (
    <div className="App">
      {isAuthed ? (
        <ChatDialog userInfo={authedUser} onLogout={handleLogout} />
      ) : (
        <AuthPage onAuthSuccess={handleAuthSuccess} />
      )}
    </div>
  );
}

export default App;
